import React from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import '../Steps.scss';
import { StepProps, steps } from '../Steps';
import { StoreState } from '@mm/state/store-interfaces';
import { SET_TOUR } from '@mm/state/modules/modalsState/actions';
import { trackWebAppGAEvent } from '../../../../common/helpers/plugins/website-google-analytics';

export const StepHeader = (props: StepProps) => {
  const { step, close } = props;
  const dispatch: Dispatch<StoreState> = useDispatch();
  const onClose = () => {
    trackWebAppGAEvent('click', {
      category: 'modals',
      label: `ui_tour_header_end_button`,
    });
    close();
    dispatch({
      type: SET_TOUR,
      payload: false,
    });
  };
  return (
    <div className="step-header__container">
      <span>
        {step}
        <span className="step-header__total-steps">/{steps.length}</span>
      </span>

      {step !== steps.length && (
        <span className="step-header__end-tour" onClick={onClose}>
          End Tour
        </span>
      )}
    </div>
  );
};
